import { TypographyCaption } from '@heidi/design-system/typography';
import { cn } from '@heidi/utils';
import { Loader2 } from 'lucide-react';

import type { JSX } from 'react';

interface EvidenceToolFallbackPillProps {
  name: string;
  label?: string;
  active: boolean;
}

export const EvidenceToolFallbackPill = ({
  name,
  label,
  active,
}: EvidenceToolFallbackPillProps): JSX.Element => (
  <div className="flex items-center gap-2 rounded-md border border-border bg-surface px-2.5 py-1.5">
    <Loader2
      className={cn('size-3.5 shrink-0 text-text-tertiary', active && 'animate-spin')}
    />
    <TypographyCaption className="truncate text-text-secondary">
      {label ?? name.replace(/_/g, ' ')}
    </TypographyCaption>
  </div>
);
